<template>
  <div>
    <CCard class="mob-pd-0px">
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <CRow class="flex-flow-column w-100">
          <CCol>
            <!-- <strong v-if="GET_SELECTED_AGENT_GROUP==null">{{ $t("newAgentGroup.addAgtGrp") }}</strong>
            <strong v-else>{{ $t("newAgentGroup.editAgtGrp") }}</strong> -->

            <strong v-if="agtGrp.groupname" class="text-transform-uppercase">{{agtGrp.groupname}}</strong>
              <strong v-else>{{ $t("newAgentGroup.addAgtGrp") }}</strong>
          </CCol>

          <!-- <p class="desc" >{{ // $t("contract.desc") }}</p> -->
           <p class="desc text-ellipsis d-block" v-if="agtGrp.description">{{agtGrp.description}}</p>
           <p class="desc text-ellipsis d-block" v-else>{{ $t("newAgentGroup.agtGrpDesc") }}</p>
        </CRow>

        
      </CCardHeader>
<ValidationObserver v-slot="{ handleSubmit }">
                                   
                                    <form @submit.prevent="handleSubmit(toSaveAgtGrp)"  >
      <CCardBody class="user-manage-table pt-0px max-width-550 m-auto">
      
<div class="max-w-850">
    <div class="row mt-20px mb-20px">
        <div v-if="GET_SELECTED_AGENT_GROUP!=null">

        </div>
        <div v-else class="col-md-12 col-sm-12 mb-10px">
            <cTextInputComponent
            @onInput="onEdit"
                    v-model="agtGrp.groupname"
                    :placeholder="$t('newAgentGroup.grpNamePl')"
                    :name="$t('newAgentGroup.grpName')"
                    :label="$t('newAgentGroup.grpName')"
                    class=""
                    rules="required|max:50|noInitialSpace"
            />
        </div>
        <div v-if="GET_SELECTED_AGENT_GROUP!=null"></div>
        <div v-else class="col-md-12 col-sm-12 mb-10px">
            <cTextInputComponent
            @onInput="onEdit"
                    v-model="agtGrp.description"
                    :placeholder="$t('newAgentGroup.descPl')"
                    :name="$t('newAgentGroup.desc')"
                    :label="$t('newAgentGroup.desc')"
                     rules="required|max:300|noInitialSpace"
                    class=" "
            />
        </div>
        <div class="col-md-12 col-sm-12 mb-10px">
            <div class="">
                <cAgent
                        v-model="agtGrp.agency"
                        :ctrlName="'agencyname'"
                        :ctrlCode="'b2bid'"
                        :isShowCode="true"
                        :isSearchable="true"
                        @input="onChangeAgent"
                        :isMultiple="true"
                        :isAll="true"
                        :agentType="'null'"
                        :rules="'required'"
                        :label="$t('newAgentGroup.addAgents')"
                />
            </div>
<!--            <div class="">-->

<!--                <div class="row">-->
<!--                    <div class="col-7 m-auto">-->
<!--&lt;!&ndash;                        <label>{{$t('newAgentGroup.addAgents')}}</label>&ndash;&gt;-->
<!--                     -->
<!--                    </div>-->
<!--                </div>-->

<!--            </div>-->
        </div>
        
    </div>

</div>

        <cAlertModal
                v-if="isShowAlertModal"
                :key="'CA'+alertCount"
                :buttonList="modalButton"
                :status="modalStatus"
                :isShowIcon="true"
                :show="isShowAlertModal"
                :desc="confirmTxt"
        ></cAlertModal>

        <CRow>
          <CAlert v-if="alertValue" show color="danger">
            <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
              <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
            </div>
            <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
              <span>{{$t("cAlert.errorCode")+' : '}}</span>
              <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
            </div>
            <div v-if="alertValue&&alertValue.constructor==String">
              <p>{{alertValue}}</p>
            </div>
          </CAlert>
        </CRow>
        
      </CCardBody>
      <CCardFooter>
        <CRow class="justify-content-end">
          <CButton @click="navToAgtGrpPage()" color="danger" class="action-c-btn mr-15px">{{$t('newAgentGroup.cancelBtn')}}</CButton>
          <CButton
            col="12"
            type="submit"
            color="success removewrap"
            class="action-c-btn mr-15px"
          >{{$t('newAgentGroup.saveBtn')}}</CButton>
        </CRow>
      </CCardFooter>
       </form>
                                </ValidationObserver>
    </CCard>
  </div>
</template>

<script>
import router, { navigate, updateDataEdited } from "../../router/index";
import cTextInputComponent from "../../components/form/cTextInputComponent";
import { mapGetters, mapActions } from "vuex";
import { ValidationProvider } from "vee-validate";
import cAgent from "../../components/form/cAgent";
import { PATHNAME, COMPONENT_NAME,
        ALERT_MODAL_STATUS} from "../../util/constants";
import apiCreateB2bGroup from "../../services/apiCreateB2bGroup";
// import apiGetAllAirline from "../../services/apiGetAllAirline";
import apiUpdateB2bGroup from "../../services/apiUpdateB2bGroup"
import Logger from "../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../config/API_DATA";
import cAlertModal from "../../components/form/cAlertModal"
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList
} from "../../util/util";
import BaseConfiguration from "../../config/base.js";
import multiselect from "vue-multiselect";
import { isPastDate } from "../../util/date/dateFunctions";
import {ValidationObserver, localize, Validator} from "vee-validate";
import CreateB2bGroup from '../../services/apiCreateB2bGroup';


export default {
  name: COMPONENT_NAME.AGENTGROUP_NEW,
  components: {
    
    ValidationProvider,
            ValidationObserver,
   cAgent,
    cTextInputComponent,
    multiselect,
    cAlertModal
  },

  data: () => {
    return {
      alertValue: null,
      showTicketDate: true,
      airlineOption: [],
      crsOption: [],
      agtGrp: {
        groupname:null,
        description:null,
        agency:null,
        b2bIds:null
      },
      alertCount:0,
      modalStatus: ALERT_MODAL_STATUS.INFO,
                modalButton: null,
                isShowAlertModal: false,
    };
  },

  methods: {

    onEdit() {
    try {
      if(BaseConfiguration.isDebug) console.log("onEdit");
      
         updateDataEdited(true)
    } catch (err) {
            let body = Logger.buildRequest(
              COMPONENT_NAME.AGENTGROUP_NEW,
              "error in onEdit",
              err.toString(),
              "onEdit",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
      
    }, 

       onChangeAgent(pAgent) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeAgent");
       
        if (pAgent) {
          this.agtGrp.b2bIds=[]
          for (let i = 0; i < pAgent.length; i++) {
            this.agtGrp.b2bIds.push(pAgent[i].b2bid);
          }
        }
        this.onEdit();
      } catch (err) {
        let body = Logger.buildRequest(
         FILE_NAME.C_EDIT_TICKETS,
          "error in onChangeAgent",
          err.toString(),
          "onChangeAgent",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    navToAgtGrpPage() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToContractPage");
        // updateDataEdited(true);
        navigate(PATHNAME.AGENTGROUP_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.AGENTGROUP_NEW,
          "error in navToContractPage",
          err.toString(),
          "navigateToAddContract",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async CreateB2bGroup() {
      if (BaseConfiguration.isDebug) console.log("CreateB2bGroup");
      let returnValue;
      try {
        let CreateB2bGroupReq = apiCreateB2bGroup.buildRequest(this.agtGrp); //constant
        this.isShowAlertModal = false;
        updateDataEdited(false);
        if (CreateB2bGroupReq != null) {
          let CreateB2bGroupRes = await apiCreateB2bGroup.getResponse(
            CreateB2bGroupReq
          );
          if (VALIDATE_SUCCESS_RES(CreateB2bGroupRes)) {
            returnValue = CreateB2bGroupRes.data.data;
            this.showAlertModal(
                                ALERT_MODAL_STATUS.SUCCESS,
                                this.$t("newAgentGroup.addSuccess")
                            );
                            this.alertValue=null;
          } else {
            let error = getErrorMessage(CreateB2bGroupRes);
            
            let isJwt = handleJWT(error);
            if (!isJwt) {
            this.alertValue = getErrorAlertValue(error,true,true);            }
            this.showAlertModal(
              ALERT_MODAL_STATUS.FAIL,
              this.alertValue
            );
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  getCreateB2bGroup",
          err.toString(),
          "getCreateB2bGroup()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },


    async updateB2bGroup() {
      if (BaseConfiguration.isDebug) console.log("updateB2bGroup");
      let returnValue;
      try {
        this.isShowAlertModal = false;
        updateDataEdited(false);
        let updateB2bGroupReq = apiUpdateB2bGroup.buildRequest(this.GET_SELECTED_AGENT_GROUP,this.agtGrp); //constant

        if (updateB2bGroupReq != null) {
          let updateB2bGroupRes = await apiUpdateB2bGroup.getResponse(
            updateB2bGroupReq
          );
          if (VALIDATE_SUCCESS_RES(updateB2bGroupRes)) {
            returnValue = updateB2bGroupRes.data.data;
            
                            this.showAlertModal(
                                ALERT_MODAL_STATUS.SUCCESS,
                                this.$t("newAgentGroup.editSuccess")
                            );
                            this.alertValue=null;
          } else {
            let error = getErrorMessage(updateB2bGroupRes);
            
            let isJwt = handleJWT(error);
            if (!isJwt) {
             this.alertValue = getErrorAlertValue(error,true,true);
            }
            this.showAlertModal(
              ALERT_MODAL_STATUS.FAIL,
              this.alertValue
            );
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  getupdateB2bGroup",
          err.toString(),
          "getupdateB2bGroup()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

  

    toSaveAgtGrp() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toSaveAgtGrp");
                    if(this.GET_SELECTED_AGENT_GROUP && this.agtGrp.b2bIds.length==0){
                      this.onChangeAgent(this.GET_SELECTED_AGENT_GROUP.b2bCompanyGroupMembers);
                    }
                    this.GET_SELECTED_AGENT_GROUP? 
                    
                    this.showAlertModal(
                        ALERT_MODAL_STATUS.INFO,
                        this.$t("newAgentGroup.editConfirm")
                    ):this.showAlertModal(
                        ALERT_MODAL_STATUS.INFO,
                        this.$t("newAgentGroup.addConfirm")
                    );
                   
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.EXTENSION_SETUP,
                        "error in toSaveAgtGrp",
                        err.toString(),
                        "toSaveAgtGrp",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
  },

            showAlertModal(status, val) {
                this.isShowAlertModal = true;
                this.alertCount += 1;
                this.modalStatus = status;

                if (status == ALERT_MODAL_STATUS.INFO) {
                    this.modalButton = [
                        {
                            name: this.$t("newAgentGroup.no"),
                            func: this.toggleShowAlertModal
                        },
                        {
                            name: this.$t("newAgentGroup.yes"),
                            func: this.GET_SELECTED_AGENT_GROUP?
                                  this.updateB2bGroup : this.CreateB2bGroup
                        }
                    ];
                } else if (status == ALERT_MODAL_STATUS.SUCCESS || status == ALERT_MODAL_STATUS.FAIL) {
                    this.modalButton = [
                        {
                            name: this.$t("newAgentGroup.ok"),
                            func: this.navigateToAllAgtGrp
                        }
                    ];
                }
                this.confirmTxt = val;
            },

            navigateToAllAgtGrp() {
                this.isShowAlertModal = !this.isShowAlertModal;
                // updateDataEdited(false);
                navigate(PATHNAME.AGENTGROUP_ALL);
                this.modalStatus = ALERT_MODAL_STATUS.INFO;
            },

             toggleShowAlertModal() {
              //  updateDataEdited(true);
                this.isShowAlertModal = !this.isShowAlertModal;
                this.modalStatus = ALERT_MODAL_STATUS.INFO;
            },

            toAssignAgentGroupObj(pAgtGrpObj) {
              let retValue ={
                  groupname:null,
                  description:null,
                  agency:null,
                  b2bIds:null
                    };
                try {
                  if(BaseConfiguration.isDebug) console.log("toAssignAgentGroupObj");
                  retValue.groupname = pAgtGrpObj.groupname;
                  retValue.description = pAgtGrpObj.description;
     
                  let agencyGrp={
                      agencyname: null,
                      b2bcode: null,
                      b2bid: null}
                  let agtgrpLs=[];
                  for (let i = 0; i < pAgtGrpObj.b2bCompanyGroupMembers.length; i++) {
                    if(pAgtGrpObj.b2bCompanyGroupMembers[i].b2b){
                       pAgtGrpObj.b2bCompanyGroupMembers[i]["agencyname"] = pAgtGrpObj.b2bCompanyGroupMembers[i].b2b.agencyname;
                       pAgtGrpObj.b2bCompanyGroupMembers[i]["b2bcode"] = pAgtGrpObj.b2bCompanyGroupMembers[i].b2b.b2bcode;
                       pAgtGrpObj.b2bCompanyGroupMembers[i]["b2bid"] = pAgtGrpObj.b2bCompanyGroupMembers[i].b2bId;
                      }
                    }
                retValue.agency = pAgtGrpObj.b2bCompanyGroupMembers;
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.EXTENSION_SETUP,
                          "error in toAssignAgentGroupObj",
                          err.toString(),
                          "toAssignAgentGroupObj",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
          }, 

    
  },

  async created() {
    try {
      if(this.GET_SELECTED_AGENT_GROUP){
        this.agtGrp=this.toAssignAgentGroupObj(this.GET_SELECTED_AGENT_GROUP)
      }
        updateDataEdited(true);
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.AGENTGROUP_NEW,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {
    ...mapGetters("sAgentGroup", {
      GET_SELECTED_AGENT_GROUP: "GET_SELECTED_AGENT_GROUP"
    }),
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.AGENTGROUP_NEW);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>
